import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import { getCategory } from 'lib/api/common';

import Icon from 'components/atoms/Icon';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewButton from 'components/molecules/NewButton';
import Modal from 'components/organisms/NewModal';

const useStyles = makeStyles((theme) => ({
  cateListWrap: {
    display: 'inline-flex',
    height: 300,
    margin: '10px 0',
    border: theme.palette.box.border,
    borderRadius: 4,
    fontSize: 14,
    '& span': {
      marginRight: 10,
      fontSize: 12,
      color: theme.palette.common.gray2,
    },
    '& .selected': { backgroundColor: theme.palette.common.selectedGreen },
    '& > .info': {
      width: 180,
      padding: '130px 0',
      margin: 0,
      textAlign: 'center',
    },
  },
  mainCateList: {
    minWidth: 150,
    overflow: 'auto',
    borderRight: theme.palette.box.border,
    cursor: 'pointer',
    '& > div': {
      padding: '14px 10px',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.primary[50],
      },
    },
  },
  listWrap: {
    display: 'flex',
    overflow: 'hidden',
    cursor: 'pointer',
    '& > div': {
      overflow: 'auto',
      minWidth: 150,
      borderRight: theme.palette.box.border,
      '&:last-child': {
        borderRight: 'none',
      },
      '& > div': {
        padding: '14px 10px',
        display: 'flex',
        alignItems: 'center',
        '&:hover': {
          backgroundColor: theme.palette.primary[50],
        },
      },
    },
  },
  selectedArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: theme.palette.box.border,
    borderRadius: 4,
    padding: '0 10px',
    '& > p > span': {
      fontWeight: 'bold',
    },
  },
  newBtn: {
    '&.disabled': {
      backgroundColor: 'rgb(234,234,234 ,26%)',
      borderColor: 'rgb(0, 0, 0, 0.26)',
      pointerEvents: 'none',
      color: 'rgba(0, 0, 0, 0.38)',
      '& > div': { color: 'rgba(0, 0, 0, 0.38)', backgroundColor: 'initial' },
      '& > .mb-division': { backgroundColor: 'rgb(0, 0, 0, 0.26)' },
    },
  },
}));

const Mapping = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const { params, getParam, disabled, name = 'ctgrSeq' } = props;

  const [loading, setLoading] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const initSelectedCode = {
    main: '',
    middle: '',
    small: '',
    sub: '',
  };
  const [selectedCode, setSelectedCode] = useState(initSelectedCode);
  const [selectedParams, setSelectedParams] = useState({});
  const [selectedLabel, setSelectedLabel] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getCategory({
      userTpCode: '01',
      sDate: !!params.sDate ? params.sDate : null,
      eDate: !!params.eDate ? params.eDate : null,
    })
      .then((response) => {
        const { data } = response.data;
        setCategoryList(data);
      })
      .catch((error) => {
        setCategoryList([]);
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!!params[name]) {
      setSelectedParams({
        [name]: params[name],
      });
      for (const i in categoryList) {
        if (categoryList[i]['CTGR_SEQ'] === params[name]) {
          setSelectedLabel(categoryList[i]['CTGR_NM']);
          return;
        } else {
          if (!!categoryList[i]['SUB']) {
            for (const middleI in categoryList[i]['SUB']) {
              if (
                categoryList[i]['SUB'][middleI]['CTGR_SEQ'] === params[name]
              ) {
                setSelectedLabel(categoryList[i]['SUB'][middleI]['CTGR_NM']);
                return;
              } else {
                if (!!categoryList[i]['SUB'][middleI]['SUB']) {
                  for (const subI in categoryList[i]['SUB'][middleI]['SUB']) {
                    if (
                      categoryList[i]['SUB'][middleI]['SUB'][subI][
                        'CTGR_SEQ'
                      ] === params[name]
                    ) {
                      setSelectedLabel(
                        categoryList[i]['SUB'][middleI]['SUB'][subI]['CTGR_NM']
                      );
                      return;
                    }
                  }
                }
              }
            }
          }
        }
      }
      // categoryList.forEach((item) => {
      //   if (item['CTGR_SEQ'] === params[name]) {
      //     return;
      //   } else {
      //     console.log('item["SUB"] => ', item['SUB']);
      //     item['SUB'].forEach((subItem) => {
      //       console.log('subItem => ', subItem);
      //       if (subItem['CTGR_SEQ'] === params[name]) {
      //         setSelectedLabel(item['CTGR_NM']);
      //         return;
      //       }
      //     });
      //   }
      // });
    } else {
      setSelectedLabel('');
      setSelectedParams({});
    }
    // eslint-disable-next-line
  }, [params, categoryList]);

  const handleSubCate = (type, value) => {
    let newSelectCode = { ...selectedCode };
    if (type === 'middle') {
      newSelectCode = {
        ...newSelectCode,
        sub: '',
        small: '',
      };
    } else if (type === 'small') {
      newSelectCode = {
        ...newSelectCode,
        sub: '',
      };
    }
    setSelectedCode({
      ...newSelectCode,
      [type]: value,
    });
    setSelectedParams({
      [name]: value,
    });
  };

  const handleModalOpen = () => {
    setOpen(!open);
  };

  const handleConfirm = () => {
    setOpen(false);
    getParam({ ...params, ...selectedParams });
    // setSelectedCode(initSelectedCode);
  };

  const handleModalClose = () => {
    setOpen(false);
    // setSelectedParams({});
    // setSelectedCode(initSelectedCode);
  };
  const handleDelete = () => {
    const newParams = { ...params };
    delete newParams[name];
    getParam(newParams);
    setOpen(false);
    setSelectedCode(initSelectedCode);
  };
  return (
    <>
      <NewButton
        className={clsx(classes.newBtn, !!disabled && 'disabled')}
        onClick={(e) => handleModalOpen()}
        disableRipple
        filtered={!!params[name]}
      >
        카테고리필터{!!selectedLabel && ' : ' + selectedLabel}
      </NewButton>
      <Modal
        open={open}
        headerTitle={t('카테고리 필터')}
        handleClose={() => handleModalClose()}
        confirmBtnOpen
        confirmOnClick={() => handleConfirm()}
        style={{ minWidth: 620 }}
      >
        {loading ? (
          <CurrentStatus type="loading" />
        ) : (
          <>
            {!!selectedLabel && (
              <div className={classes.selectedArea}>
                <p>
                  <span>{t('선택된 카테고리')}: </span>
                  {selectedLabel}
                </p>
                <NewButton onClick={(e) => handleDelete()} disableRipple>
                  선택된 카테고리 삭제
                </NewButton>
              </div>
            )}

            <div className={classes.cateListWrap}>
              <>
                {(() => {
                  const result = [];
                  const middleResult = [];
                  const smallResult = [];
                  const subResult = [];
                  categoryList.forEach((category, key) => {
                    const { ADVER_CNT, USE_ADVER_CNT, CTGR_NM, CTGR_SEQ, SUB } =
                      category;
                    const selected = selectedCode.middle === CTGR_SEQ;

                    middleResult.push(
                      <div
                        key={key}
                        className={clsx({ selected })}
                        onClick={() => handleSubCate('middle', CTGR_SEQ)}
                      >
                        {CTGR_NM}
                        <span>
                          (
                          <b style={{ color: theme.palette.primary.deep }}>
                            {numeral(USE_ADVER_CNT).format()}
                          </b>
                          /{numeral(ADVER_CNT).format()})
                        </span>
                        {selected && ADVER_CNT > 0 && (
                          <Icon
                            icon={'faAngleRight'}
                            color={theme.palette.primary.deep}
                            className={classes.icon}
                            style={{ marginLeft: 'auto' }}
                          />
                        )}
                      </div>
                    );
                    if (!!selectedCode.middle) {
                      SUB.forEach((smallCategory, smallKey) => {
                        const {
                          HIRNK_CTGR_SEQ,
                          ADVER_CNT,
                          USE_ADVER_CNT,
                          CTGR_NM,
                          CTGR_SEQ,
                        } = smallCategory;
                        const selected = selectedCode.small === CTGR_SEQ;
                        if (selectedCode.middle === HIRNK_CTGR_SEQ) {
                          smallResult.push(
                            <div
                              key={`${HIRNK_CTGR_SEQ}_${smallKey}`}
                              className={clsx({ selected })}
                              onClick={() => handleSubCate('small', CTGR_SEQ)}
                            >
                              {CTGR_NM}
                              <span>
                                (
                                <b
                                  style={{ color: theme.palette.primary.deep }}
                                >
                                  {numeral(USE_ADVER_CNT).format()}
                                </b>
                                /{numeral(ADVER_CNT).format()})
                              </span>
                              {selected && ADVER_CNT > 0 && (
                                <Icon
                                  icon={'faAngleRight'}
                                  color={theme.palette.primary.deep}
                                  className={classes.icon}
                                  style={{ marginLeft: 'auto' }}
                                />
                              )}
                            </div>
                          );
                        }
                        if (!!selectedCode.small) {
                          smallCategory.SUB.forEach((subCategory, smallKey) => {
                            const {
                              HIRNK_CTGR_SEQ,
                              ADVER_CNT,
                              USE_ADVER_CNT,
                              CTGR_NM,
                              CTGR_SEQ,
                            } = subCategory;
                            const selected = selectedCode.sub === CTGR_SEQ;
                            if (selectedCode.small === HIRNK_CTGR_SEQ) {
                              subResult.push(
                                <div
                                  key={`${HIRNK_CTGR_SEQ}_${smallKey}`}
                                  className={clsx({ selected })}
                                  onClick={() => handleSubCate('sub', CTGR_SEQ)}
                                >
                                  {CTGR_NM}
                                  <span>
                                    (
                                    <b
                                      style={{
                                        color: theme.palette.primary.deep,
                                      }}
                                    >
                                      {numeral(USE_ADVER_CNT).format()}
                                    </b>
                                    /{numeral(ADVER_CNT).format()})
                                  </span>
                                </div>
                              );
                            }
                          });
                        }
                      });
                    }
                  });
                  result.push(
                    <div key="categoryList" className={classes.listWrap}>
                      <div key="middle" className={classes.middleCateList}>
                        {middleResult}
                      </div>
                      {!!selectedCode.middle && smallResult.length > 0 && (
                        <div key="small" className={classes.smallCateList}>
                          {smallResult}
                        </div>
                      )}
                      {!!selectedCode.small && subResult.length > 0 && (
                        <div key="sub" className={classes.subCateList}>
                          {subResult}
                        </div>
                      )}
                    </div>
                  );
                  return result;
                })()}
              </>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default Mapping;
